<template>
  <div class="invite-code-guide">
    <div class="invite-code-guide__inner">
      <div class="invite-code-guide__row">
        <span class="typo-caption-xs-medium">•</span>
        <span class="typo-caption-xs-medium">초대코드는 계정당 1회만 입력할 수 있어요.</span>
      </div>
      <div class="invite-code-guide__row">
        <span class="typo-caption-xs-medium">•</span>
        <span class="typo-caption-xs-medium">초대 코드는 입력 후 변경할 수 없어요.</span>
      </div>
      <div class="invite-code-guide__row">
        <span class="typo-caption-xs-medium">•</span>
        <span class="typo-caption-xs-medium">추천인 등록 시점 기준, 연속혈당측정기 구매 이력이 있는 계정은 이벤트 대상에서 제외됩니다.</span>
      </div>
    </div>

    
  </div>
</template>

<script>
export default {
  name: 'InviteCodeGuide',
}
</script>

<style scoped>
.invite-code-guide {
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 600px;
  padding: 0 16px;
  box-sizing: border-box;
}

.invite-code-guide__inner {
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 12px;
  background: var(--color-bg-gray, #F2F4F6);
}

.invite-code-guide__row {
  display: flex;
  align-self: stretch;
  gap: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/InviteCodeGuide.vue